export const TransitionProposalsStatusMap = {
    draft: "Draft",
    processing: "Processing",
    processed: "Processed",
    complete: "Complete",
    shared: "Shared",
};
// -- Transition Proposal Import Types --
export const TransitionProposalsImportTypeMap = {
    statement: "Statement",
    existing: "Existing",
    manual: "Manual",
};
//# sourceMappingURL=types.js.map